<template>
  <transition-group name="notifications" tag="div" class="notifications-wrapper">
    <button type="button" v-for="notification in notifications" :key="notification.id" class="notification" :class="notification.class" @click="hide(notification.id)">
      <div class="notification-icon">
        <svg v-if="notification.class === 'error' || notification.class === 'warning'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 500 438">
          <path fill="#fff" d="m251.09.03.55.03.54.06.55.07.54.08.54.1.54.11.54.12.53.14 1.06.32.52.18 1.04.4.51.22.51.23.5.25.49.25.5.27.48.28.48.29.47.3.47.32.46.32.45.33.44.35.44.36.43.36.42.38.41.38.4.4.39.4.76.84.36.43.35.44.34.45.33.46.32.46 228.12 393.75.31.47.29.48.27.49.26.5.24.5.23.5.21.52.19.52.18.52.17.53.15.54.13.54.12.54.1.55.08.55.07.55.06.56.04.56.02.56.01.57-.01.57-.02.57-.04.57-.06.57-.07.57-.08.57-.1.57-.12.58-.13.57-.15.57-.17.57-.18.57-.19.57-.21.57-.23.56-.24.56-.26.56-.27.56-.29.55-.31.55-.31.54-.33.53-.7 1.02-.36.49-.37.48-.38.47-.4.46-.4.44-.41.43-.42.42-.43.41-.43.39-.45.38-.45.37-.46.35-.46.34-.47.33-.48.31-.49.3-.49.29-.5.27-.5.26-.51.24-.51.23-.51.22-.52.2-.53.19-.53.17-.53.16-.53.14-.54.13-.53.12-.55.1-.54.08-.54.07-.55.06-.54.03-.55.03-.55.01H21.87l-.54-.01-1.1-.06-.54-.06-.54-.07-.55-.08-.54-.1-.54-.12-.53-.13-.54-.14-.53-.16-.52-.17-.53-.19-.52-.2-.51-.22-.52-.23-.5-.24-.51-.26-.49-.27-.49-.29-.49-.3-.48-.31-.47-.33-.47-.34-.46-.35-.45-.37-.44-.38-.44-.39-.42-.41-.42-.42-.41-.43-.41-.44-.39-.46-.38-.47-.37-.48-.37-.49-.35-.51-.34-.51-.33-.53-.32-.54-.3-.48-.29-.48-.27-.5-.26-.51-.24-.51-.23-.53-.21-.53-.2-.54-.18-.55-.16-.55-.15-.56-.13-.56-.12-.57-.1-.58-.09-.57-.07-.58-.05-.59-.04-.58-.02-.58-.01-.59.01-.59.02-.58.04-.59.05-.58.07-.58.09-.58.1-.57.12-.57.13-.56.15-.56.16-.56.18-.54.2-.54.21-.54.23-.52.24-.52.26-.5.27-.5.29-.48.3-.48L231.25 10.41l.32-.46.33-.46.34-.45.35-.44.36-.43.37-.42.39-.42.39-.4.4-.4.41-.38.42-.38.86-.72.45-.35.45-.33.92-.64.48-.3.48-.29.48-.28.49-.27 1-.5.51-.23.51-.22 1.04-.4.52-.18 1.06-.32.53-.14.54-.12.54-.11.54-.1.54-.08.54-.07.55-.06.55-.03.54-.03h1.1l.54.03Zm-3.88 329.25-1.37.14-1.36.2-1.34.25-1.33.3-1.3.36-1.29.41-1.26.45-1.24.51-1.22.55-1.19.59-1.17.64-1.14.69-1.12.72-1.08.77-1.05.81-1.03.85-.99.88-.95.92-.92.95-.88.99-.85 1.02-.81 1.06-.76 1.08-.73 1.11-.68 1.14-.64 1.17-.6 1.2-.55 1.22-.51 1.24-.45 1.26-.41 1.29-.35 1.3-.31 1.33-.25 1.34-.2 1.36-.14 1.37-.09 1.39-.03 1.4.03 1.4.09 1.38.14 1.38.2 1.36.25 1.34.31 1.32.35 1.31.41 1.28.45 1.27.51 1.24.55 1.22.6 1.19.64 1.17.68 1.14.73 1.11.76 1.09.81 1.05.85 1.02.88.99.92.96.95.92.99.88 1.03.84 1.05.81 1.08.77 1.12.73 1.14.68 1.17.64 1.19.6 1.22.55 1.24.5 1.26.46 1.29.4 1.3.36 1.33.3 1.34.26 1.36.19 1.37.15 1.39.08 1.4.03 1.4-.03 1.39-.08 1.37-.15 1.36-.19 1.34-.26 1.32-.3 1.31-.36 1.28-.4 1.27-.46 1.24-.5 1.22-.55 1.19-.6 1.17-.64 1.14-.68 1.12-.73 1.08-.77 1.05-.81 1.02-.84.99-.88.96-.92.92-.96.88-.99.85-1.02.8-1.05.77-1.09.73-1.11.68-1.14.64-1.17.6-1.19.55-1.22.5-1.24.46-1.27.41-1.28.35-1.31.31-1.32.25-1.34.2-1.36.14-1.38.08-1.38.03-1.4-.03-1.4-.08-1.39-.14-1.37-.2-1.36-.25-1.34-.31-1.33-.35-1.3-.41-1.29-.46-1.26-.5-1.24-.55-1.22-.6-1.2-.64-1.17-.68-1.14-.73-1.11-.77-1.08-.8-1.06-.85-1.02-.88-.99-.92-.95-.96-.92-.99-.88-1.02-.85-1.05-.81-1.08-.77-1.12-.72-1.14-.69-1.17-.64-1.19-.59-1.22-.55-1.24-.51-1.27-.45-1.28-.41-1.31-.36-1.32-.3-1.34-.25-1.36-.2-1.37-.14-1.39-.09-1.4-.03-1.4.03-1.39.09ZM218.75 217.7l10.42 83.34h41.66l10.42-83.34 3.12-83.33h-68.75l3.13 83.33Z" />
        </svg>
        <svg v-if="notification.class === 'success'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="200" height="145.55" viewBox="0 0 200 145.55">
          <defs>
            <path id="a" fill="#1b9000" d="m80.25 96.17-55.6-55.61L0 65.22l55.6 55.6-.07.08 24.65 24.65L200 24.65 175.35 0z" />
          </defs>
          <use xlink:href="#a" />
        </svg>
      </div>

      <div class="notification-text">
        <p class="title">{{ notification.title }}</p>
        <p v-if="notification.status" class="status">(Error code: {{ notification.status }})</p>
        <p class="descr">{{ notification.descr }}</p>
      </div>
    </button>
  </transition-group>
</template>

<script setup>
import { inject } from 'vue';
const { notifications, hide } = inject('$notification');
</script>

<style lang="scss">
.notifications-wrapper {
  position: fixed;
  bottom: 50px;
  right: 0px;
  z-index: 1051;

  .notification {
    position: relative;
    min-width: 350px;
    max-width: 420px;
    color: white;
    padding: 25px 20px 25px 26px;
    border-radius: 0px 0px 0px 0px;
    margin-top: 15px;
    margin-left: auto;
    border: none;
    display: block;
    box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.659);

    .notification-icon {
      margin-top: auto;
      margin-right: 15px;
      padding-right: 15px;
      position: absolute;
      top: 50%;
      left: 30px;
      transform: translateY(-50%);

      svg,
      img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 25px;
      }
    }

    .notification-text {
      position: relative;
      text-align: left;
      font-size: 15px;
      margin: 0;
      letter-spacing: 0.04rem;
      padding-left: 60px;

      &::before {
        content: "";
        display: block;
        position: absolute;
        left: 42px;
        top: 50%;
        width: 1px;
        height: 35px;
        transform: translateY(-50%);
      }

      .title {
        font-size: 0.9375rem;
        font-weight: 500;
        text-transform: uppercase;
      }

      .status {
        font-size: 0.75rem;
        font-weight: 500;
        opacity: 0.75;
      }

      .descr {
        margin-top: 7px;
        font-size: 0.5625rem;
        font-weight: 400;
      }
    }

    &.success {
      background: #60fe06;
      color: #000;

      .notification-text {
        &::before {
          background-color: #1b9000;
        }
      }
    }

    &.warning {
      background: #f49a00;
      color: #000;
    }

    &.error {
      background: #ff0000;
      color: #fff;

      .notification-text {
        &::before {
          background-color: #fff;
        }
      }
    }
  }
}

.notifications-enter-active,
.notifications-leave-active {
  transition: opacity 250ms ease-in-out, transform 250ms ease-in-out;
}

.notifications-enter-from,
.notifications-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

// XL (1200px)
@media only screen and (min-width: 1200px) {
  .notifications-wrapper {
    bottom: 80px;

    .notification {
      padding: 25px 50px 25px 24px;
    }
  }
}
</style>